import { toStringValue } from "features/shared/lib/formatters";

import type { ShadingSystemCatalogItem } from "../model/types";
import type { WindowConfigFormState } from "./windowConfigFieldDefinitions";

import { normalizeShadingLocationToForm } from "./windowConfigOptions";

export const mapShadingCatalogItemToFormFields = (
  item: ShadingSystemCatalogItem
): Pick<
  WindowConfigFormState,
  | "gValueDiffuseWindowShading"
  | "gValueDirectWindowShading"
  | "maxWindAverage"
  | "maxWindExtreme"
  | "shadingLocation"
  | "shadingSystemType"
> => ({
  gValueDiffuseWindowShading: toStringValue(item.radiationTransitionDiffuse),
  gValueDirectWindowShading: toStringValue(item.radiationTransitionDirect),
  maxWindAverage: toStringValue(item.cutOffWindGust),
  maxWindExtreme: toStringValue(item.cutOffWindSpeed),
  shadingLocation: normalizeShadingLocationToForm(item.location),
  shadingSystemType: item.shadingSystemType,
});
